export default __webpack_public_path__ + "static/media/mode-18.156125d9.svg";